import dytUpload from './dyt-upload.vue';

export default dytUpload;
